import React, { useEffect, useState, useMemo } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Modal,
  ModalBody,
  ModalHeader
} from "reactstrap"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"
import axios from "axios"
import configure from "configure"
import moment from "moment"
import secureLocalStorage from "react-secure-storage";

// Components & Assets
import InfoGif from "../../../assets/images/GIF/question-mark.gif"
import NewPagination from "components/Common/Newpagination"
import Loader from "../../Separate/Loader"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import "../../../assets/css/Staff/Staff.css"
import {
  FetchNodePostData,
  FetchNodePostIndData,
} from "utils/common-fetchData";

// --- HELPER FUNCTIONS ---
const getInitials = (name) => {
  if (!name) return "ST";
  const names = name.trim().split(" ");
  return names.length > 1
    ? (names[0][0] + names[names.length - 1][0]).toUpperCase()
    : names[0][0].toUpperCase();
};

// --- TABLE CONTAINER COMPONENT (Styled like Code 1) ---
function TableContainer({ columns, data }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state,
    setPageSize,
    gotoPage,
    canPreviousPage,
    previousPage,
    canNextPage,
    nextPage,
    pageOptions,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageSize: 50,
        sortBy: [
          {
            id: "start_date", // The accessor of the column to sort by
            desc: false,           // 'false' for date_of_joining puts the oldest date (most experience) first
          },
        ],
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state


  return (
    <div>
      {/* Heading, Search & Page Size Row - Styled like Code 1 */}
      <Row className="mb-3">
        <Col className="d-flex justify-content-start align-items-center">
          <h5 className="text-purple fw-bold mb-0">Notes - Meeting status</h5>
        </Col>
        <Col className="d-flex justify-content-end align-items-center gap-2">
          {/* Page Size */}
          <select
            className="form-select w-auto"
            value={pageSize}
            onChange={e => setPageSize(Number(e.target.value))}
          >
            {[10, 25, 50, 100].map((size, i) => (
              <option key={i} value={size}>
                Show {size}
              </option>
            ))}
          </select>

          {/* Search */}
          <input
            className="form-control w-25"
            placeholder="Search staff..."
            value={globalFilter || ""}
            onChange={e => setGlobalFilter(e.target.value)}
          />
        </Col>
      </Row>

      {/* Table - Styled like Code 1 */}
      <Table bordered hover responsive {...getTableProps()} className="mt-4">
        <thead>
          {headerGroups.map((hg, i) => (
            <tr key={i} {...hg.getHeaderGroupProps()}>
              {hg.headers.map((col, j) => (
                <th key={j} {...col.getHeaderProps(col.getSortByToggleProps())}>
                  <div className="d-flex align-items-center justify-content-between">
                    {col.render("Header")}
                    <span>
                      {col.isSorted ? (col.isSortedDesc ? <i className="bx bx-down-arrow-alt" /> : <i className="bx bx-up-arrow-alt" />) : ""}
                    </span>
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)


            return (
              <tr key={i} {...row.getRowProps()}>
                {/* //   style={{ backgroundColor: backgroundColor }}> */}
                {row.cells.map((cell, j) => (
                  <td key={j} {...cell.getCellProps()}>
                    {cell.render("Cell")}
                  </td>
                ))}
              </tr>
            )
          })}
        </tbody>
      </Table>

      {/* Pagination - Consistent with Code 1 */}
      <NewPagination
        gotoPage={gotoPage}
        canPreviousPage={canPreviousPage}
        previousPage={previousPage}
        canNextPage={canNextPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        page={page}
        data={data}
        nextPage={nextPage}
      />
    </div>
  )
}

// --- MAIN COMPONENT ---
const MeetingNotes = () => {
  const [isLoading, setLoading] = useState(true)
  const [modal_Access, setAccessDenied] = useState(false)

  const [staffList, setStaffList] = useState([]);
  const [meetingData, setMeetingData] = useState([]);
  const [noteCounts, setNoteCounts] = useState({});
  const token = secureLocalStorage.getItem("auth_token")

  const [meetingNotesMap, setMeetingNotesMap] = useState({});
  const [selectedNotes, setSelectedNotes] = useState([]);
  const [notesModal, setNotesModal] = useState(false);

  document.title = "Dashboard | Zithas Crm"

  const onEditPermission = async (row) => {
    const { id, meeting_type } = row;

    setLoading(true);
    const formData = new FormData();
    formData.append("user_id", localStorage.getItem("auth_id"));
    formData.append("module_id", 17);
    try {
      await axios({
        method: "post",
        url: `${configure.apiUrl}/earth_permission`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        if (res.data.data.india[4] == 1 || res.data.data.uk[4] == 1) {

          let editUrl = "";

          //Lead
          if (Number(meeting_type) == 2) {
            editUrl = `${configure.appUrl}sales/edit-lead/${id}?tab=notes`;
          }

          //Customer
          else if (Number(meeting_type) == 4) {
            editUrl = `${configure.appUrl}sales/edit-customer/${id}?tab=notes`;
          }

          //Introducer
          else if (Number(meeting_type) == 3) {
            editUrl = `${configure.appUrl}sales/edit-introducer/${id}?tab=notes`;
          }

          else {
            alert("Edit not configured for this meeting type.");
            setLoading(false);
            return;
          }

          window.open(editUrl, "_blank", "noopener,noreferrer");
        } else {
          setAccessDenied(true);
        }
        setLoading(false);
      });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllStaff()
  }, [])

  const fetchAllStaff = async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${configure.apiUrl}/staff`, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      const activeStaff =
        (response.data?.data || []).filter(item => item.status == 0);

      setStaffList(activeStaff);

      // After staff loaded → call calendar
      const staffIds = activeStaff.map(staff => staff.id);
      console.log(`here are all staff ids ${staffIds}`);
      getMeetings(staffIds);

    } catch (error) {
      console.error("Error fetching staff:", error);
    }
  };

  const getMeetings = async (staffIds) => {
    try {
      const response = await axios.post(
        "http://localhost:5000/api/calender/get",
        { id: staffIds },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data?.status) {
        const meetings = response.data.data || [];
        console.log("calender response", meetings);

        const formatted = meetings.map((item, index) => ({
          id: item.id,
          sr: index + 1,
          title: item.title,
          start_date: item.start,
          attendees: item.user_details
            ?.map(u => u.alias_name)
            .join(", "),
          meeting_type: item.project,
          meeting_with_id: item.meeting_with_id,
        }));

        setMeetingData(formatted);

        // fetch notes count
        formatted.forEach(meeting => {
          handleProjectNotes(meeting);
        });
      }

    } catch (error) {
      console.log("Calendar Fetch Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleProjectNotes = async (meeting) => {
    const { meeting_type, meeting_with_id, id, start_date } = meeting;

    if (!meeting_with_id) return;

    try {
      let notes = [];

      if (meeting_type == 2) {
        notes = await fetchLeadNotes(meeting_with_id);
      }
      else if (meeting_type == 4) {
        notes = await fetchCustomerNotes(meeting_with_id);
      }
      else if (meeting_type == 3) {
        notes = await fetchIntroducerNotes(meeting_with_id);
      }

      // filter notes only on meeting date
      // const meetingDay = moment.utc(start_date);

      // const filteredNotes = notes.filter(note =>
      //   moment(note.created_at, "YYYY-MM-DD HH:mm:ss")
      //     .isSame(meetingDay, "day")
      // );

      const meetingDay = moment.utc(start_date).format("YYYY-MM-DD");

      const filteredNotes = notes.filter(note => {
        const noteDay = moment(note.created_at, "YYYY-MM-DD HH:mm:ss")
          .format("YYYY-MM-DD");

        console.log("Meeting Date:", meetingDay);
        console.log("Note Date:", noteDay);

        return noteDay === meetingDay;
      });

      setNoteCounts(prev => ({
        ...prev,
        [id]: filteredNotes.length
      }));
      // console.log(noteCounts);
      setMeetingNotesMap(prev => ({
        ...prev,
        [id]: filteredNotes
      }));

    } catch (error) {
      console.log(error);
    }
  };

  // const handleViewNotes = (row) => {
  //   const notes = meetingNotesMap[row.id] || [];
  //   setSelectedNotes(notes);
  //   setNotesModal(true);
  // };

  const fetchLeadNotes = async (leadId) => {
    try {
      const formData = new FormData();
      formData.append("lead_id", leadId);
      formData.append("user_id", localStorage.getItem("auth_id"));

      const response = await axios.post(
        `${configure.apiUrl}/all_lead_data`,
        formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        }
      );

      //setNoteData(response.data.data?.lead_note || []);
      return response.data.data?.lead_note || [];
    } catch (err) {
      console.log(err);
    } finally {
    }
  };

  const fetchCustomerNotes = async (customerId) => {
    try {
      const formData = new FormData();
      formData.append("customer_id", customerId);

      const response = await axios.post(
        `${configure.apiUrl}/customer_notes`,
        formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        }
      );

      //setNoteData(response.data.data || []);
      return response.data.data || [];
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const fetchIntroducerNotes = async (introducerId) => {
    try {
      const formData = new FormData();
      formData.append("introducerId", introducerId);

      const response = await axios.post(
        `${configure.apiUrl}/introducer_notes`,
        formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        }
      );

      //setNoteData(response.data.data || []);
      return response.data.data || [];
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "Sr No",
        accessor: "sr",
      },
      {
        Header: "Title",
        accessor: "title",
      },
      {
        Header: "Start Date",
        accessor: "start_date",
        Cell: ({ value }) =>
          value ? moment(value).format("DD-MM-YYYY HH:mm") : "-",
      },
      {
        Header: "Attendees",
        accessor: "attendees",
      },
      {
        Header: "Meeting Type",
        accessor: "meeting_type",
        Cell: ({ value }) => {
          const map = {
            1: "Project",
            2: "Lead",
            3: "Introducer",
            4: "Customer",
            5: "Other",
            6: "Internal",
            7: "Interview",
          }
          return map[value] || "-"
        },
      },
      {
        Header: "No of Notes",
        accessor: "notes_count",
        Cell: ({ row }) => {
          return noteCounts[row.original.id] || 0;
        },
      },
      {
        Header: "Action",
        accessor: "action",
        Cell: ({ row }) => {
          const { meeting_type } = row.original;
          const canEdit = [2, 3, 4].includes(Number(meeting_type));
          return (
            <div>
              {/* <a
                            className="btn btn-sm btn-outline-secondary me-1"
                            title="View Proposal"
                            // onClick={() => handleViewNotes(row.original)}
                        >
                            <i className="fas fa-eye "></i>
                        </a> */}

              {canEdit &&
                (<button onClick={() => onEditPermission(row.original)} title='edit' className='btn btn-sm btn-outline-secondary me-1'>
                  <i className="fas fa-plus me-2 icon-size label-icon"></i>
                  Add Note
                </button>)
              }
            </div>
          )
        },
      },
    ],
    [noteCounts]
  )

  const filteredMeetingData = useMemo(() => {
    return meetingData.filter(meeting => {
      const isValidType = [2, 3, 4].includes(Number(meeting.meeting_type));
      const notesCount = noteCounts[meeting.id] || 0;

      return isValidType && notesCount === 0;
    });
  }, [meetingData, noteCounts]);

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <Card>
        <CardBody>
          <TableContainer
            columns={columns}
            data={filteredMeetingData}
          />
        </CardBody>
      </Card>


      {modal_Access && <AccessDeniedPopup />}

      {/* <Modal
        isOpen={notesModal}
        toggle={() => setNotesModal(false)}
        size="lg"
        centered
      >
        <ModalHeader toggle={() => setNotesModal(false)}>
          Meeting Notes
        </ModalHeader>
        <ModalBody style={{ maxHeight: "70vh", overflowY: "auto" }}>
          {selectedNotes.length > 0 ? (
            <ul className="verti-timeline list-unstyled notes-box">
              {selectedNotes.map((note, index) => (
                <li key={index} className="event-list position-relative">
                  <div className="d-flex">
                    <div className="flex-grow-1 ms-4 note py-2 rounded ps-3 pr-3">
                      <div className="d-flex justify-content-between">
                        <div>
                          <h6 className="d-inline me-2">
                            By {note.added_by}
                          </h6>
                          {moment(note.created_at).format(
                            "DD-MM-YYYY hh:mm:ss"
                          )}
                        </div>
                      </div>

                      <div
                        dangerouslySetInnerHTML={{
                          __html: note.description,
                        }}
                      />
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-center mb-0">No notes found for this meeting date.</p>
          )}
        </ModalBody>
      </Modal> */}
    </React.Fragment>
  )
}

export default MeetingNotes